import axios from 'axios';
import { createAsyncThunk, createSlice, isPending, isRejected } from '@reduxjs/toolkit';
import { API_ROUTES } from '@/config/api-routes';
import { deriveKpiReference, mapKpiDashboardResponse } from '../model/kpi-dashboard.model';
import { serializeAxiosError, resolveAsyncThunkErrorMessage } from './reducer.utils';
const apiBase = API_ROUTES.reports.kpiDashboard;
const initialState = {
    loading: false,
    errorMessage: null,
    reference: null,
    analytics: null,
};
function buildQueryParams(params) {
    const q = new URLSearchParams();
    if (params.startDate)
        q.set('startDate.equals', params.startDate);
    if (params.endDate)
        q.set('endDate.equals', params.endDate);
    if (params.agents?.length)
        q.set('agents.in', params.agents.join(','));
    if (params.queues?.length)
        q.set('queues.in', params.queues.join(','));
    if (params.shifts?.length)
        q.set('shifts.in', params.shifts.join(','));
    if (params.chartType)
        q.set('chartType.equals', params.chartType);
    return q;
}
export const getKpiDashboardAnalytics = createAsyncThunk('kpiDashboard/analytics', async (params) => {
    const qs = buildQueryParams(params).toString();
    const response = await axios.get(`${apiBase}${qs ? `?${qs}` : ''}`);
    return mapKpiDashboardResponse(response.data);
}, { serializeError: serializeAxiosError });
export const kpiDashboardSlice = createSlice({
    name: 'kpiDashboard',
    initialState: initialState,
    reducers: {
        clearKpiDashboard(state) {
            state.analytics = null;
            state.errorMessage = null;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(getKpiDashboardAnalytics.fulfilled, (state, action) => {
            state.loading = false;
            state.analytics = action.payload;
            state.reference = deriveKpiReference(action.payload.agents);
        })
            .addMatcher(isPending(getKpiDashboardAnalytics), (state) => {
            state.loading = true;
            state.errorMessage = null;
        })
            .addMatcher(isRejected(getKpiDashboardAnalytics), (state, action) => {
            state.loading = false;
            state.errorMessage = resolveAsyncThunkErrorMessage(action.error);
        });
    },
});
export const { clearKpiDashboard } = kpiDashboardSlice.actions;
export default kpiDashboardSlice.reducer;
